import React from "react";

// Optional per-column `w` (min-width) / `max` (max-width) — number=px or
// CSS width string — let a column size itself to its own content instead
// of being force-stretched by the table's `w-full` auto layout just
// because a neighboring column (e.g. an empty "Description") has no
// content to anchor it. Omit both for a column to keep it fully auto.
const toCss = (v) => typeof v === 'number' ? `${v}px` : v;
const colStyle = (c) => {
  if (c.w == null && c.max == null) return undefined;
  const style = {};
  if (c.w != null) style.minWidth = toCss(c.w);
  if (c.max != null) style.maxWidth = toCss(c.max);
  return style;
};

// Always add a trailing unconstrained spacer column so *it* absorbs the
// table's leftover width instead of the browser's table-auto layout
// spreading that slack out between the real columns — without this, a
// table full of short values (an ID, a time, a status pill) stretched
// every column far past its content, leaving big dead gaps in each field.
// `bare` drops the outer rounded/border/shadow card so a caller can compose
// the table with its own footer (e.g. a <Pagination> bar) inside one
// shared card instead of stacking two separately-bordered boxes.
export const Tbl = ({ cols, data, bare, onRowClick }) => {
  const renderCols = [...cols, { k: "__spacer", l: "" }];
  const inner = <div className="overflow-x-auto">
    <table className="w-full border-collapse text-[14px]">
      <thead>
        <tr className="bg-bg2/80">
          {renderCols.map(c => <th key={c.k} style={colStyle(c)} className="px-3 py-[11px] text-left text-t2 font-bold text-[11px] uppercase tracking-wider border-b border-b0 whitespace-nowrap">{c.l}</th>)}
        </tr>
      </thead>
      <tbody className="divide-y divide-b0">
        {data.map((row, i) =>
          <tr key={i} onClick={onRowClick ? () => onRowClick(row) : undefined} className={`group hover:bg-sh transition-colors${onRowClick ? " cursor-pointer" : ""}`}>
            {renderCols.map(c => <td key={c.k} style={colStyle(c)} className={`px-3 py-[10px] text-t1 ${c.wrap ? "whitespace-normal break-words" : "whitespace-nowrap overflow-hidden text-ellipsis"}`}>{c.r ? c.r(row) : row[c.k]}</td>)}
          </tr>
        )}
      </tbody>
    </table>
  </div>;
  if (bare) return inner;
  return <div className="rounded-2xl border border-b0 overflow-hidden shadow-card">{inner}</div>;
};
